import { checkResponse } from "utils";

const { axios } = window;

// 注册用户列表
export const getZcUserList = params => {
  return axios.post(`/customer/list/sql`, params).then(checkResponse);
};
// 样本搜索注册用户列表接口
export const customerSqlList = params => {
  return axios.post(`/customer/list/sql`, params).then(checkResponse);
};
// 平台端：企业账户列表
export const getPlamQyCountList = params => {
  return axios.get(`/company/captial/list`, { params }).then(checkResponse);
};
// 平台端：用户资金列表
export const getPlamYhCountList = params => {
  return axios.get(`/customer/captial/list`, { params }).then(checkResponse);
};

// 平台端：平台企业资金总和
export const getPlamQyTotalMoney = params => {
  return axios.get(`/company/captial/sum`, { params }).then(checkResponse);
};

// 平台端：企业列表
export const getCompanyList = params => {
  return axios.get(`/company/list`, { params }).then(checkResponse);
};
// 根据手机号获取信息
export const customerInfo = params => {
  return axios.get(`/customer/info`, { params }).then(checkResponse);
};
// 创建企业
export const companyCreate = params => {
  return axios.post(`/company/create`, params).then(checkResponse);
};
// 修改企业
export const companyUpdate = params => {
  return axios.put(`/company/update/${params.id}`, params).then(checkResponse);
};
// 获取行业
export const getIndustry = () => {
  return axios.get(`/json/industry.json`, { baseURL: "" }).then(checkResponse);
};
// 企业服务列表
export const getServices = params => {
  return axios.get(`/company/service/list`, { params }).then(checkResponse);
};
// 获取服务名称配置
export const getServicesSet = params => {
  return axios
    .get(`/company/service/setting/info`, { params })
    .then(checkResponse);
};
// 设置服务名称配置
export const putServicesSet = params => {
  return axios.put(`/company/service/set`, params).then(checkResponse);
};
// 交易实体模糊搜索
export const tradeSearchApi = params => {
  return axios.get(`/transaction/entity`, { params }).then(checkResponse);
};
// 交易记录列表
export const tradeListApi = params => {
  return axios.get(`/transaction/plat/list`, { params }).then(checkResponse);
};
// 平台端：银联支付交易列表
export const tradeYinLianListApi = params => {
  return axios
    .get(`/transactionUnipay/list/platform`, { params })
    .then(checkResponse);
};
// 交易记录渠道
export const tradeRecordChanelApi = () => {
  return axios.get(`/transaction/channel`).then(checkResponse);
};
// 交易记录类型
export const tradeRecordTypeApi = params => {
  return axios.get(`/transaction/type`, { params }).then(checkResponse);
};
//  项目列表
export const companyDomainList = params => {
  return axios.get(`/companyDomain/list`, { params }).then(checkResponse);
};
// 创建项目域名
export const companyDomainCreate = params => {
  return axios.post(`/companyDomain/create`, params).then(checkResponse);
};
// 修改项目域名
export const companyDomainPut = params => {
  return axios.put(`/companyDomain/update`, params).then(checkResponse);
};
// 用户新建企业
export const companyUsrCreate = params => {
  return axios.post(`/company/usr/create`, params).then(checkResponse);
};
// 平台端：企业定制是否生效
export const settingEffectPut = (companyId, effect) => {
  return axios
    .put(`/company/setting/effect?companyId=${companyId}&effect=${effect}`)
    .then(checkResponse);
};
// 平台端: 公众号配置详细
export const officialAccountList = params => {
  return axios.get(`/officialAccount/info`, { params }).then(checkResponse);
};
// 平台端: 创建公众号配置
export const officialAccountCreate = params => {
  return axios.post(`/officialAccount/create`, params).then(checkResponse);
};
// 平台端: 创建公众号配置
export const officialAccountUpdate = (params, officialId) => {
  return axios
    .put(`/officialAccount/update?officialId=${officialId}`, params)
    .then(checkResponse);
};
//  平台端：小程序配置详细
export const miniProgramInfo = params => {
  return axios.get(`/miniProgram/info`, { params }).then(checkResponse);
};
// 平台端：创建小程序配置
export const miniProgramCreate = params => {
  return axios.post(`/miniProgram/create`, params).then(checkResponse);
};
// 平台端：修改小程序配置
export const miniProgramUpdate = (params, miniId) => {
  return axios
    .put(`/miniProgram/update?miniId=${miniId}`, params)
    .then(checkResponse);
};
// 平台端：app文件配置列表
export const installFileList = params => {
  return axios.get(`/installFile/list`, { params }).then(checkResponse);
};
// 平台端：app文件配置详细
export const installFileDetail = params => {
  return axios.get(`/installFile/info`, { params }).then(checkResponse);
};
// 平台端：创建app文件配置
export const installFileCreate = params => {
  return axios.post(`/installFile/create`, params).then(checkResponse);
};
// 平台端：通用Apk文件配置列表
export const genApkList = () => {
  return axios.get(`/installFile/default/list`).then(checkResponse);
};
// 平台端：创建通用app文件配置
export const createGenApp = params => {
  return axios.post(`/installFile/create/default`, params).then(checkResponse);
};
// 企业端：通用上传app文件配置详细
export const uploadApp = params => {
  return axios.get(`/installFile/create`, params).then(checkResponse);
};
// 平台端：平台管理员列表
export const platAdminList = params => {
  return axios.get(`/usr/list`, { params }).then(checkResponse);
};
// 平台端：移出平台管理员
export const moveoutAdmin = usrId => {
  return axios.delete(`/usr/delete?usrId=${usrId}`).then(checkResponse);
};
// 平台端：修改平台管理员状态
export const modifyAdminStatePut = (usrId, status) => {
  return axios
    .put(`/usr/update/status?usrId=${usrId}&status=${status}`)
    .then(checkResponse);
};
// 平台端：创建平台管理员(注册账户转化)
export const createAdminPost = params => {
  return axios.post(`/usr/customer/transfer`, params).then(checkResponse);
};
// 平台端：修改平台管理员
export const modifyAdminPut = (usrId, params) => {
  return axios.put(`/usr/update?usrId=${usrId}`, params).then(checkResponse);
};
// 平台端：平台管理员详细
export const getAdminInfo = usrId => {
  return axios.get(`/usr/info?usrId=${usrId}`).then(checkResponse);
};

// 注册用户详细
export const registeredUserInfo = mobile => {
  return axios
    .get(`/customer/info?mobile=${mobile}&isAdmin=${true}`)
    .then(checkResponse);
};

// 平台端：管理员角色列表
export const adminRoleList = params => {
  return axios.get(`/adminRole/list`, { params }).then(checkResponse);
};
// 平台端：删除管理员角色
export const delRoleAdmin = roleId => {
  return axios.delete(`/adminRole/delete?roleId=${roleId}`).then(checkResponse);
};
// 平台端：修改管理员角色状态
export const modifyRoleStatePut = (roleId, status) => {
  return axios
    .put(`/adminRole/update/status?roleId=${roleId}&status=${status}`)
    .then(checkResponse);
};
// 平台端：创建平台角色
export const createRole = params => {
  return axios.post(`/adminRole/create`, params).then(checkResponse);
};
// 平台端：管理平台菜单树
export const getAdminRoleTree = () => {
  return axios.get(`/adminRole/menu/tree`).then(checkResponse);
};
// 平台端：修改管理员角色
export const modifyRolePut = (roleId, params) => {
  return axios
    .put(`/adminRole/update?roleId=${roleId}`, params)
    .then(checkResponse);
};
// 平台端：管理员角色详细
export const getAdminRoleInfo = roleId => {
  return axios.get(`/adminRole/info?roleId=${roleId}`).then(checkResponse);
};
// 平台端：管理员角色列表(创建编辑平台用户使用)
export const getRoleList = () => {
  return axios.get(`/adminRole/list/for/admin`).then(checkResponse);
};
// 平台端：平台管理员权限（菜单)
export const getMenu = params => {
  return axios.get(`/usr/menu`, { params }).then(checkResponse);
};
// 平台端：编辑平台管理员默认角色
export const changeDefaultRole = roleId => {
  return axios.put(`/usr/default/role?roleId=${roleId}`).then(checkResponse);
};
// 平台端：咨询列表
export const getAskForCustom = params => {
  return axios.get(`/askForCustom/list`, { params }).then(checkResponse);
};
// 平台端：系统定制申请详细
export const getAskForCustomMore = params => {
  return axios.get(`/askForCustom/info`, { params }).then(checkResponse);
};
// 平台端：修改系统定制申请
export const changeAskForCustom = (id, params) => {
  return axios
    .put(`/askForCustom/update?askId=${id}`, params)
    .then(checkResponse);
};
// 平台端：更新系统定制申请-重点客户
export const updateLarge = (askId, large) => {
  return axios
    .put(`/askForCustom/update/large?askId=${askId}&large=${large}`)
    .then(checkResponse);
};
// 平台端：管理员查询百科
export const searchByKeywordForSuperAdmin = params => {
  return axios
    .get(`/knowledgeBase/searchByKeywordForSuperAdmin`, { params })
    .then(checkResponse);
};
// 平台端：百科左侧树
export const searchFromKnowledgeBaseDir = params => {
  return axios
    .get(`/knowledgeBase/searchFromKnowledgeBaseDir`, { params })
    .then(checkResponse);
};
// 平台端：添加知识库目录
export const createKnowledgeBaseDir = (fatherId, name, companyId) => {
  return axios
    .post(
      `/knowledgeBase/createKnowledgeBaseDir?fatherId=${fatherId}&name=${name}${
        companyId ? `&companyId=${companyId}` : ""
      }`
    )
    .then(checkResponse);
};
// 平台端：修改知识库名称
export const updateKnowledgeBaseDirName = (dirId, name, companyId) => {
  return axios
    .post(
      `/knowledgeBase/updateKnowledgeBaseDirName?dirId=${dirId}&name=${name}${
        companyId ? `&companyId=${companyId}` : ""
      }`
    )
    .then(checkResponse);
};
// 平台端：删除知识库
export const deleteKnowledgeBaseDir = dirId => {
  return axios
    .delete(`/knowledgeBase/deleteKnowledgeBaseDir?dirId=${dirId}`)
    .then(checkResponse);
};
// 平台端：上下移动目录
export const upOrDownDir = (id, direction) => {
  return axios
    .post(`/knowledgeBase/upOrDownDir?dirId=${id}&direction=${direction}`)
    .then(checkResponse);
};
// 平台端：添加百科
export const createKnowledgeBase = params => {
  return axios
    .post(`/knowledgeBase/createKnowledgeBase`, params)
    .then(checkResponse);
};
// 平台端：编辑百科
export const updateKnowledgeBase = (id, params) => {
  return axios
    .post(`/knowledgeBase/updateKnowledgeBase?id=${id}`, params)
    .then(checkResponse);
};
// 平台端：发布百科
export const publishKnowledge = id => {
  return axios
    .post(`/knowledgeBase/publishKnowledge?id=${id}`)
    .then(checkResponse);
};

// 平台端：删除文百科
export const deleteKnowledge = id => {
  return axios
    .delete(`/knowledgeBase/deleteKnowledge?id=${id}`)
    .then(checkResponse);
};
// 平台端 ：发布百科
export const publishKnowledgeUp = id => {
  return axios
    .post(`/knowledgeBase/publishKnowledge?id=${id}`)
    .then(checkResponse);
};
// 平台端 ：取消发布百科
export const cancelPublishKnowledgeBatch = (id, companyId) => {
  return axios
    .post(
      `/knowledgeBase/cancelPublishKnowledgeBatch?ids=${id}${
        companyId ? `&companyId=${companyId}` : ""
      }`
    )
    .then(checkResponse);
};
// 平台端 ：批量发布百科
export const publishKnowledgeBatch = (id, companyId) => {
  return axios
    .post(
      `/knowledgeBase/publishKnowledgeBatch?ids=${id}${
        companyId ? `&companyId=${companyId}` : ""
      }`
    )
    .then(checkResponse);
};
// 平台端 ：新闻资讯列表
export const newsList = params => {
  return axios.get(`/news/list`, { params }).then(checkResponse);
};
// 平台端：创建新闻资讯
export const createNews = params => {
  return axios.post(`/news/create`, params).then(checkResponse);
};
// 平台端：发布/取消发布新闻资讯
export const releaseNews = (newsIds, release) => {
  return axios
    .put(`/news/release?release=${release}`, newsIds)
    .then(checkResponse);
};
// 平台端：修改新闻资讯
export const updateNews = (id, params) => {
  return axios.put(`/news/update?newsId=${id}`, params).then(checkResponse);
};
// 平台端：删除新闻资讯
export const deleteNews = dirId => {
  return axios.delete(`/news/delete?newsId=${dirId}`).then(checkResponse);
};
// 平台端：新闻种类列表
export const newsTypes = params => {
  return axios.get(`/news/types`, { params }).then(checkResponse);
};
// 平台端：删除新闻资讯分类
export const deleteNewsType = dirId => {
  return axios.delete(`/newsType/delete?typeId=${dirId}`).then(checkResponse);
};
// 平台端：创建新闻资讯分类
export const createNewsType = params => {
  return axios.post(`/newsType/create`, params).then(checkResponse);
};
// 平台端：修改新闻资讯分类
export const updateNewsType = (id, params) => {
  return axios.put(`/newsType/update?typeId=${id}`, params).then(checkResponse);
};
// 平台端：创建/更新合作页文案
export const updateCooperatePage = params => {
  return axios.put(`/cooperatePage/update`, params).then(checkResponse);
};
// 用户端/企业端：获取合作页文案
export const infoCooperatePage = params => {
  return axios.get(`/cooperatePage/info`, params).then(checkResponse);
};
// 平台端：导出企业员工信息汇总
export const exportStaffList = (start, end) => {
  return axios
    .get(
      `/company/gather/excel?start=${start === undefined ? "" : start}&end=${
        end === undefined ? "" : end
      }`
    )
    .then(checkResponse);
};
// 用户内部转移可用资金专用
export const userInnerCapTrans = params => {
  return axios.post(`/freezes/balance/reward`, params).then(checkResponse);
};
// 所有可选百科标签
export const knowledgeTags = params => {
  return axios
    .get(`/knowledgeBase/knowledgeTags`, { params })
    .then(checkResponse);
};
// 平台端：个人认证列表
export const customerIdentifyList = params => {
  return axios.get(`/customerIdentify/list`, { params }).then(checkResponse);
};
// 平台端：个人认证詳情
export const customerIdentifyInfo = params => {
  return axios.get(`/customerIdentify/info`, { params }).then(checkResponse);
};
// 平台端：企業认证詳情
export const companyIdentifyInfo = params => {
  return axios.get(`/companyIdentify/info`, { params }).then(checkResponse);
};
// 平台端：企业认证列表
export const companyIdentifyList = params => {
  return axios.get(`/companyIdentify/list`, { params }).then(checkResponse);
};
// 平台端：企业认证确认
export const companyEnsure = params => {
  return axios
    .put(
      `/companyIdentify/ensure?identifyId=${params.identifyId}&ensure=${
        params.ensure
      }${params.reject ? `&reject=${params.reject}` : ""}`,
      { params }
    )
    .then(checkResponse);
};
// 平台端：个人认证
export const customerIdentifyEnsure = params => {
  return axios
    .put(
      `/customerIdentify/ensure?identifyId=${params.identifyId}&ensure=${
        params.ensure
      }${params.reject ? `&reject=${params.reject}` : ""}`,
      { params }
    )
    .then(checkResponse);
};
// 平台端：基础服务域名列表
export const baseDomainList = params => {
  return axios.get(`/baseDomain/list`, { params }).then(checkResponse);
};
// 平台端：基础服务服务上线/下线
export const onlineBaseDomain = params => {
  return axios
    .put(`/baseDomain/online?baseIds=${params.baseIds}&online=${params.online}`)
    .then(checkResponse);
};
// 平台端：创建基础服务域名
export const createBaseDomain = params => {
  return axios.post(`/baseDomain/create`, params).then(checkResponse);
};
// 平台端：修改基础服务域名
export const updateBaseDomain = params => {
  return axios
    .put(`/baseDomain/update?baseId=${params.baseId}&domain=${params.domain}`)
    .then(checkResponse);
};
// 平台端：删除基础服务域名
export const deleteBaseDomain = id => {
  return axios.delete(`/baseDomain/delete?baseId=${id}`).then(checkResponse);
};
// 搜索样本推送任务
export const searchSamplePush = params => {
  return axios.get(`/sampleTask/searchTasks`, { params }).then(checkResponse);
};
// 获取状态选项
export const getStatus = () => {
  return axios.get(`/sampleTask/statuses`).then(checkResponse);
};
// 样本任务详情
export const sampleDetails = params => {
  return axios
    .get(`/sampleTask/sampleTaskDetails`, { params })
    .then(checkResponse);
};
// 样本推送任务退回，返回值为样本推送任务ID
export const samplePushBack = params => {
  return axios.post(`/sampleTask/banTask`, params).then(checkResponse);
};
// 样本推送任务通过,返回值为样本推送任务ID
export const samplePushSuccess = id => {
  return axios.post(`/sampleTask/passTask?id=${id}`).then(checkResponse);
};
// 推送样本任务,返回值为样本推送任务ID
export const samplePush = id => {
  return axios.post(`/sampleTask/startPush?id=${id}`).then(checkResponse);
};
// 删除样本推送任务,返回值为任务ID
export const samplePushDel = id => {
  return axios.delete(`/sampleTask/deleteTask?id=${id}`).then(checkResponse);
};

// 搜索一条样本推送任务
export const searchSamplePushTask = params => {
  return axios.get(`/sampleTask/searchOneTask`, { params }).then(checkResponse);
};
// 用用户ID查询样本信息
export const showOneSample = params => {
  return axios.get(`/sample/showOneSample`, { params }).then(checkResponse);
};
// 获取微信消息模板
export const getTemplateByUseType = params => {
  return axios
    .get(`/weixinMessageTemplateDef/searchTemplateByUseType`, { params })
    .then(checkResponse);
};
// 删除微信消息模板
export const deleteTemplateByUseType = id => {
  return axios
    .delete(`/weixinMessageTemplateDef/deleteTemplate?id=${id}`)
    .then(checkResponse);
};
// 用来创建或者更新微信消息模板
export const createOrUpdateTemplate = params => {
  return axios
    .post(`/weixinMessageTemplateDef/createOrUpdateTemplate`, params)
    .then(checkResponse);
};
// 搜索微信消息任务分页列表
export const searchWeiXinMessageList = params => {
  return axios
    .get(`/weixinFanMessage/searchWeixinFanMessage`, { params })
    .then(checkResponse);
};
// 重新发送
export const reSendMessage = fanMessageId => {
  return axios
    .post(`/weixinFanMessage/reProcessFanMessage?fanMessageId=${fanMessageId}`)
    .then(checkResponse);
};
// 创建微信粉丝推送
export const createWeiXinMessagePush = params => {
  return axios
    .post(`/weixinFanMessage/createWeixinFanMessage`, params)
    .then(checkResponse);
};
// 符合条件的粉丝数量
export const meetConditionFansNumber = params => {
  return axios
    .post(`/weixinFanMessage/meetRequirementFansCount`, params)
    .then(checkResponse);
};
// 平台端：银行卡提现申请列表
export const unipayOutList = params => {
  return axios.get(`/unipayOut/list`, { params }).then(checkResponse);
};
// 平台端：银行卡提现审核
export const unipayOutStatus = params => {
  return axios.put(`/unipayOut/update/status`, params).then(checkResponse);
};
// 平台端：银行卡提现打款
export const unipayOutStatusPay = params => {
  return axios
    .put(`/unipayOut/pay/status?uniPayIds=${params}`)
    .then(checkResponse);
};
// 平台端：银行卡提现申请导出
export const unipayOutExport = params => {
  return axios.get(`/unipayOut/export`, { params }).then(checkResponse);
};
// 根据名字搜索企业
export const companySearchName = params => {
  return axios.get(`/company/search/name`, { params }).then(checkResponse);
};
// 样本性别筛选
export const sampleGenders = params => {
  return axios.get(`/sample/genders`, { params }).then(checkResponse);
};
// 样本年龄选项
export const sampleAges = params => {
  return axios.get(`/sample/ages`, { params }).then(checkResponse);
};
// 样本教育情况选项
export const sampleEducations = params => {
  return axios.get(`/sample/educations`, { params }).then(checkResponse);
};
// 样本婚姻选项
export const sampleRelations = params => {
  return axios.get(`/sample/relations`, { params }).then(checkResponse);
};
// 样本行业选项
export const sampleIndustries = params => {
  return axios.get(`/sample/industries`, { params }).then(checkResponse);
};
// 样本职业选项
export const sampleProfessions = params => {
  return axios.get(`/sample/professions`, { params }).then(checkResponse);
};
// 样本收入选项
export const sampleIncomes = params => {
  return axios.get(`/sample/incomes`, { params }).then(checkResponse);
};
// 平台端：评价列表
export const pingjiaListApi = params => {
  return axios.get(`/appraise/list`, { params }).then(checkResponse);
};
// 平台端：删除评价
export const delPingjiaApi = id => {
  return axios.delete(`/appraise/delete?appraiseId=${id}`).then(checkResponse);
};
// 平台端：批量删除评价
export const delBatchPingjiaApi = params => {
  return axios
    .delete(`/appraise/delete/batch`, { data: params })
    .then(checkResponse);
};
// 用户端/企业端：评价详细
export const pingjiaDetailApi = appraiseId => {
  return axios
    .get(`/appraise/info?appraiseId=${appraiseId}`)
    .then(checkResponse);
};
// 评价标签列表
export const pingjiaMarkListApi = (type, star) => {
  return axios
    .get(`/appraiseLabel/list?type=${type}&star=${star}`)
    .then(checkResponse);
};
// 用户端/企业端：创建评价
export const createPingjiaApi = params => {
  return axios.post(`/appraise/create`, params).then(checkResponse);
};
// 平台端：修改评价
export const modifyPingjiaApi = (appraiseId, params) => {
  return axios
    .put(`/appraise/update?appraiseId=${appraiseId}`, params)
    .then(checkResponse);
};
// 获取模板定义
export const getModelDefApi = () => {
  return axios.get(`/sampleTask/sampleTaskTemplateDef`).then(checkResponse);
};
// 模板示例图
export const getModelShowPicApi = () => {
  return axios
    .get(`/sampleTask/sampleTaskTemplateExamplePicUrl`)
    .then(checkResponse);
};
// 用来修改样本推送任务中具体发送的模板字段
export const repaireModelDataApi = (sampleTaskId, params) => {
  return axios
    .post(
      `/sampleTask/updateSampleTaskSendMap?sampleTaskId=${sampleTaskId}`,
      params
    )
    .then(checkResponse);
};
// 平台端：系统色调设置
export const setColorValue = (companyId, color) => {
  return axios
    .put(`/companySetting/hue/set?companyId=${companyId}&color=${color}`)
    .then(checkResponse);
};
// 获取企业定制配置列表
export const getColorValue = (companyId, service) => {
  return axios
    .get(`/specialSetting/list?companyId=${companyId}&service=${service}`)
    .then(checkResponse);
};
// 平台端：获取系统色调
export const getSysColor = companyId => {
  return axios
    .get(`/companySetting/hue?companyId=${companyId}`)
    .then(checkResponse);
};
// 企业端：定制系统使用手册列表
export const downFilesListApi = params => {
  return axios.get(`/manual/list`, { params }).then(checkResponse);
};
// 平台端：删除定制系统使用手册
export const downFileDelApi = id => {
  return axios.delete(`/manual/delete?id=${id}`).then(checkResponse);
};
// 平台端：创建定制系统使用手册
export const downFileAddApi = params => {
  return axios.post(`/manual/create`, params).then(checkResponse);
};
// 搜索用户
export const searchUser = keyword => {
  return axios
    .get(`/customer/searchUser?keyword=${keyword}`)
    .then(checkResponse);
};
// 平台端：换壳企业定制是否生效
export const settingReplacementPut = (companyId, replacementStatus) => {
  return axios
    .put(
      `/company/replacement?companyId=${companyId}&replacementStatus=${replacementStatus}`
    )
    .then(checkResponse);
};
// 搜索用户
export const getQrCodeData = params => {
  return axios
    .post(
      `/transaction/weixin/pay?tradeType=${params.tradeType}&fee=${params.fee}&apiVersion=${params.apiVersion}&companyId=${params.companyId}`
    )
    .then(checkResponse);
};

// 批量审核
export const ensureBatch = params => {
  return axios.put(`/customerIdentify/ensureBatch`, params).then(checkResponse);
};

// 获取企业是否开启企业定制
export function getSpecialSettingStatus(companyId) {
  return axios.get('/company/infoReplace/' + companyId)
}